// extracted by mini-css-extract-plugin
export default {"articlePaywallContainer":"WC0y0Joifq1jXovox0AC","articlePaywallContent":"v3IxsLCE2FjwoippfK4k","minHeightFullVh":"GD2RbfPbIkRvCoVVHbkz","fullScreen":"CSZoj4DQ8NQhm4bbaL1s"};